import {addToCart, removeFromCart, clearCart} from "../redux/cartSlice";
import {useSelector, useDispatch} from "react-redux";

function Cart() {

    const cartitem = useSelector((state) => state.cart.cart); // دسترسی به state
    const dispatch = useDispatch(); // برای ارسال action
    return (
        <div className='container'>
            <div>Cart</div>
            <div className="row">
                <div className="col-12">
                    {cartitem.map((c, index) => (
                            <div key={c.id}>
                                <p key={index}>{c.name} / {c.id} /</p>
                                <button onClick={() => dispatch(addToCart({id: c.id, name: c.name}))}>+</button>
                                <span>{c.quantity}</span>
                                <button onClick={() => dispatch(removeFromCart(c.id))}>
                                    {c.quantity <= 1 && <span className="text-danger">D</span>}
                                    {c.quantity > 1 && <span> -- </span>}

                                </button>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    )
}

export default Cart
